module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"pageTitle":"Gallery","content":"Content Home Page","galleryCreated":"Gallery creata","galleryUpdated":"Gallery aggiornata","newGallery":"Nuova gallery","editGallery":"Modifica gallery","formAddGallery":{"GalleryName":"Nome della gallery"}}}')
  delete Component.options._Ctor
}
